import { Box, Button, Typography } from "@mui/material";
import React from "react";
import FaqAccordion from '../Faq/FaqAccordion'
import { heading } from "../../styles/style";

export default function EmployerOverview() {
  return (
    <>
    <Box my={8}>
      <Box >
        <Box >
          <Typography
            sx={heading}
          >
            Overview
          </Typography>
        </Box>
        <Box >
        <iframe width="100%" height="400" style={{borderRadius:'30px'}} src="https://www.youtube.com/embed/ZSiXZxVpVhs" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
        </Box>
      </Box>

<Box>
  <FaqAccordion/>
</Box>

      </Box>
    </>
  );
}
